import React, { Component } from 'react';
import './PlayerItem.css'

class PlayerItem extends Component {

  renderItem() {

  }

  render() {
    return (
      <div className="player">
        <div className="player__bg" style={{backgroundImage: `url(${this.props.item.bg})`}}></div>
        <p className="player__team">{this.props.item.team}</p>
        <div className="player__img" style={{backgroundImage: `url(${this.props.item.avatar})`}}></div>

        <h2 className="player__hl">
          <span className="player__ht">{this.props.item.tag}</span>
          <span className="player__hd">{this.props.item.name}</span>
        </h2>

        <dl className="player__dl">
          <div>
            <dt className="player__dt">Earnings</dt>
            <dd className="player__dd">{"$" + this.props.item.earnings.toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1,')}</dd>
          </div>

          <div>
            <dt className="player__dt">Region</dt>
            <dd className="player__dd">{this.props.item.region}</dd>
          </div>

          <div>
            <dt className="player__dt">Country</dt>
            <dd className="player__dd">{this.props.item.country}</dd>
          </div>
        </dl>
      </div>
    );
  }
}

export default PlayerItem;


// WEBPACK FOOTER //
// ./src/PlayerItem.jsx